import React, { useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styles from '../styles/pages/ForgotPassword.module.css';
import base from '../styles/Base.module.css';
import DefaultPage from './DefaultPage';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm';

const ForgotPassword: React.FC<RouteComponentProps> = () => {
  const [complete, setComplete] = useState(false);
  return (
    <DefaultPage header={{ title: 'Restore Password' }}>
      <div className={[base.actionBox, base.actionBoxFullWidth].join(' ')}>
        <p className={[base.sectionText, styles.text].join(' ')}>
          {complete ? (
            'Thank you!'
          ) : (
            <>
              Please enter your email address below.
              <br />
              You will receive an email with further instructions.
            </>
          )}
        </p>
        <ForgotPasswordForm onComplete={() => setComplete(true)} />
      </div>
    </DefaultPage>
  );
};

export default withRouter(ForgotPassword);
